import * as THREE from 'three'

import starVs from './shaders/star.vert'
import starFs from './shaders/star.frag'

const params = {
	textureSize: 2048,
	size: 1,
}

export let starTexture = (renderer) => {
	let scene = new THREE.Scene()

	const camera = new THREE.OrthographicCamera(
		params.size / -2,
		params.size / 2,
		params.size / 2,
		params.size / -2,
		0.01,
		10,
	)
	scene.add(camera)
	camera.position.z = 10
	camera.lookAt(scene.position)

	let renderTarget = new THREE.WebGLRenderTarget(
		params.textureSize,
		params.textureSize,
		{
			wrapS: THREE.RepeatWrapping,
			wrapT: THREE.RepeatWrapping,
			generateMipmaps: true,
			minFilter: THREE.LinearMipmapLinearFilter,
			magFilter: THREE.LinearMipmapLinearFilter,
			format: THREE.RGBFormat,
			encoding: THREE.sRGBEncoding,
		},
	)

	const geometry = new THREE.PlaneGeometry(params.size, params.size)
	const material = new THREE.ShaderMaterial({
		uniforms: {
			uTime: { value: 0 },
			uColTemp: { value: 1 },
			uColTempMult: { value: 0.8 },
		},
		vertexShader: starVs,
		fragmentShader: starFs,
		transparent: true,
		//depthTest: false,
		depthWrite: false,
		blending: THREE.AdditiveBlending,
		side: THREE.FrontSide,
	})

	const mesh = new THREE.Mesh(geometry, material)

	scene.add(mesh)

	renderer.setRenderTarget(renderTarget)
	renderer.clear()
	renderer.render(scene, camera)
	renderer.setRenderTarget(null)

	return renderTarget.texture
}
